import * as React from 'react';
import { UserLine } from './UserLine';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { UserService } from '../../../services/UserService';
import { FiltreUserType, FieldSort } from './Filter';
import { UserRole } from '../../../types/UserRole';

export interface Props {
    userFilter: FiltreUserType;
    fieldSort: FieldSort;
}

interface State {
    listUser: ReqType.UserView[];
}

/**
 * Ce composant permet d'afficher la liste des utilisateurs du site
 */
export class ListUser extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            listUser: []
        };
        this.getListeUser();
    }

    render() {
        // alert(' ' + this.state.listUser.length + ' ');
        const filteredList = this.filterList(this.state.listUser);
        const sortedList = this.orderList(filteredList);
        const listItems = sortedList.map(
            (user: ReqType.UserView) => {
                return (
                    <UserLine
                        user={user}
                        key={user.id}
                        changeCallback={this.changeCallback}
                    />
                );
            }
        );

        return (
            <div>
                <TableChorinitia
                    header={
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Photo</th>
                                <th scope="col">Nom</th>
                                <th scope="col">Prenom</th>
                                <th scope="col">Pseudo</th>
                                <th scope="col">Email</th>
                                <th scope="col">Voir Profil</th>
                                <th scope="col" />
                            </tr>
                        </thead>
                    }
                >
                    <tbody>
                        {listItems}
                    </tbody>
                </TableChorinitia>
            </div>
        );
    }

    private getListeUser(): void {
        UserService.getInstance().getUsers().then(
            (listUser: ReqType.UserView[]) => {
                this.setState({
                    listUser: listUser
                });

            }
        ).catch(
            (error) => {
                alert(JSON.stringify(error));
            }
        );
    }

    private changeCallback = (user: ReqType.UserView) => {
        var oldUserIndex = this.state.listUser.findIndex(
            (userElem: ReqType.UserView) => {
                return (userElem.id === user.id);
            }
        );
        if (oldUserIndex !== undefined) {
            return (UserService.getInstance().editUser(user, this.state.listUser[oldUserIndex])
                .then(
                    () => {
                        this.state.listUser[oldUserIndex].status = user.status;
                        this.setState({ listCourses: this.state.listUser });
                    }
                ).catch(
                    (e: object) => alert(JSON.stringify(e))
                )
            );
        } else {
            return Promise.reject('');
        }
    }

    private filterList(list: ReqType.UserView[]) {
        if (this.props.userFilter === FiltreUserType.TOUS) {
            return list.filter(
                (user: ReqType.UserView) => { return true; }
            );
        } else if (this.props.userFilter === FiltreUserType.ADMIN) {
            return list.filter(
                (user: ReqType.UserView) => { return user.user_type_id === UserRole.ADMIN; }
            );
        } else if (this.props.userFilter === FiltreUserType.MEMBER) {
            return list.filter(
                (user: ReqType.UserView) => { return user.user_type_id === UserRole.MEMBER; }
            );
        } else if (this.props.userFilter === FiltreUserType.SEMI_PRO) {
            return list.filter(
                (user: ReqType.UserView) => { return user.user_type_id === UserRole.SEMI_PRO; }
            );
        } else if (this.props.userFilter === FiltreUserType.USER) {
            return list.filter(
                (user: ReqType.UserView) => { return user.user_type_id === UserRole.USER; }
            );
        } else {
            return list;
        }
    }

    private orderList(list: ReqType.UserView[]) {
        if (this.props.fieldSort === FieldSort.NOM_ASC) {
            return list.sort(
                (a: ReqType.UserView, b: ReqType.UserView) => {
                    if (a.userProfile !== null && b.userProfile !== null) {
                        return a.userProfile.nom.localeCompare(b.userProfile.nom);
                    } else if (a.userProfile === null) {
                        return 1;
                    } else if (b.userProfile === null) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            );
        } else if (this.props.fieldSort === FieldSort.NOM_DES) {
            return list.sort(
                (a: ReqType.UserView, b: ReqType.UserView) => {
                    if (a.userProfile !== null && b.userProfile !== null) {
                        return b.userProfile.nom.localeCompare(a.userProfile.nom);
                    } else if (a.userProfile === null) {
                        return 1;
                    } else if (b.userProfile === null) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            );
        } else if (this.props.fieldSort === FieldSort.PSEUDO_ASC) {
            return list.sort(
                (a: ReqType.UserView, b: ReqType.UserView) => {
                    return a.username.localeCompare(b.username);
                }
            );
        } else if (this.props.fieldSort === FieldSort.PSEUDO_DEC) {
            return list.sort(
                (a: ReqType.UserView, b: ReqType.UserView) => {
                    return b.username.localeCompare(a.username);
                }
            );
        } else {
            return list;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/UserListPage/internalComponents/ListUser.tsx